// POS by plan. The server (pos_tier / pos_assert_tier, pos_phase11) is the
// authority; this mirrors it so screens hide what the plan doesn't include.
//   基本 → lite · 專業 → standard · 旗艦 → full
import { getLocale } from "../../lib/i18n.js";

// Chinese for zh-HK, English otherwise (same rule as the owner screens).
export const zhEn = (zh, en) => (getLocale() || "zh-HK").startsWith("zh") ? zh : en;
// Some POS screens keep translated labels in module-level constants (tab lists,
// status names, …), read once when the POS first loads. Flag that, so a later
// language switch reloads the page instead of leaving them in the old language.
if (typeof window !== "undefined") window.__petosPosLoaded = true;
// Locale for dates and times on screen: Hong Kong style for Chinese, UK style otherwise.
export const dateLocale = () => (getLocale() || "zh-HK").startsWith("zh") ? "zh-HK" : "en-GB";
export const POS_TIER_RANK = { off: 0, lite: 1, standard: 2, full: 3 };
const TIER_PLAN = { lite: ["基本版", "Basic"], standard: ["專業版", "Pro"], full: ["旗艦版", "Enterprise"] };
export const posTierPlan = (tier) => TIER_PLAN[tier] ? zhEn(...TIER_PLAN[tier]) : "";
export const POS_DEFAULT_MAX = { lite: 100, standard: 500, full: null };

export function posTierOf(tenant, plans) {
  if (!tenant?.posEnabled) return "off";
  const f = plans?.[tenant.plan || "free"]?.features?.pos;
  if (f === "lite" || f === "standard" || f === "full") return f;
  return tenant.plan === "enterprise" ? "full" : tenant.plan === "pro" ? "standard" : "lite";
}
export const posAllows = (tier, need) => (POS_TIER_RANK[tier] || 0) >= (POS_TIER_RANK[need] || 0);

// What each tab needs. Tabs not listed are in every tier.
export const POS_TAB_NEED = { inventory: "standard", promotions: "standard", shift: "standard", purchasing: "full" };

export const posUpgradeText = (need) => zhEn("升級" + posTierPlan(need) + "先用得到", "Needs the " + posTierPlan(need) + " plan");
